import { LanguageTranslationKeys } from 'i18n/languages/en';

import { ROUTES } from '@common/constants/CampusRoutes';

type BreadcrumbRouteConfig = {
	href: string;
	labelKey: LanguageTranslationKeys;
};

const BREADCRUMB_ROUTE_CONFIG: Record<string, BreadcrumbRouteConfig> = {
	[ROUTES.HOME]: { href: '/home', labelKey: 'routes.home' },
	'/home': { href: '/home', labelKey: 'routes.home' },
	[ROUTES.ACCESS]: { href: ROUTES.ACCESS, labelKey: 'routes.access' },
	[ROUTES.AUTH]: { href: ROUTES.AUTH, labelKey: 'routes.auth' },
	[ROUTES.NEWS]: { href: ROUTES.NEWS, labelKey: 'routes.news' },
	[ROUTES.BOOKS]: { href: ROUTES.BOOKS, labelKey: 'routes.resources' },
	[ROUTES.PROGRAMS]: { href: ROUTES.PROGRAMS, labelKey: 'routes.programs' },
	[ROUTES.LESSONS]: { href: ROUTES.LESSONS, labelKey: 'routes.lessons' },
	[ROUTES.REPORT]: { href: ROUTES.REPORT, labelKey: 'routes.report' },
	[ROUTES.CERTIFICATES]: { href: ROUTES.CERTIFICATES, labelKey: 'routes.certificates' },
	[ROUTES.ACHIEVEMENT]: { href: ROUTES.ACHIEVEMENT, labelKey: 'routes.achievements' },
	[ROUTES.ABOUT]: { href: ROUTES.ABOUT, labelKey: 'routes.about' },
	[ROUTES.STRENGTHS]: { href: ROUTES.STRENGTHS, labelKey: 'routes.strengths' },
	[ROUTES.GOALS]: { href: ROUTES.GOALS, labelKey: 'routes.goals' },
	[ROUTES.STEPS]: { href: ROUTES.STEPS, labelKey: 'routes.steps' },
	[ROUTES.CREATE]: { href: ROUTES.CREATE, labelKey: 'routes.create' },
	[ROUTES.PORTFOLIO]: { href: ROUTES.PORTFOLIO, labelKey: 'routes.portfolio' },
	[ROUTES.INDIVIDUALITY]: {
		href: ROUTES.INDIVIDUALITY,
		labelKey: 'routes.individuality',
	},
	[ROUTES.INTERESTS]: { href: ROUTES.INTERESTS, labelKey: 'routes.interests' },
	[ROUTES.QUALITIES]: { href: ROUTES.QUALITIES, labelKey: 'routes.qualities' },
	[ROUTES.APPOINTMENTS]: { href: ROUTES.APPOINTMENTS, labelKey: 'routes.appointments' },
	[ROUTES.PROFILE]: { href: ROUTES.PROFILE, labelKey: 'routes.profile' },
	[ROUTES.GRADEBOOK]: { href: ROUTES.GRADEBOOK, labelKey: 'routes.gradebook' },
	[ROUTES.MONTH]: { href: ROUTES.MONTH, labelKey: 'routes.month' },
	[ROUTES.CHAT]: { href: ROUTES.CHAT, labelKey: 'routes.chat' },
	[ROUTES.HOMEWORK]: { href: ROUTES.HOMEWORK, labelKey: 'routes.homework' },
	[ROUTES.POLICIES]: { href: ROUTES.POLICIES, labelKey: 'routes.policies' },
	[ROUTES.MARKET]: { href: ROUTES.MARKET, labelKey: 'routes.market' },
	[ROUTES.PAYMENT]: { href: ROUTES.PAYMENT, labelKey: 'routes.payment' },
	[ROUTES.ONBOARDING]: { href: ROUTES.ONBOARDING, labelKey: 'routes.onboarding' },
	[ROUTES.TESTS]: { href: ROUTES.TESTS, labelKey: 'routes.tests' },
	[ROUTES.DASHBOARD]: { href: ROUTES.DASHBOARD, labelKey: 'routes.dashboard' },
	[ROUTES.EDUCATION]: { href: ROUTES.EDUCATION, labelKey: 'routes.education' },
	[ROUTES.FINANCIAL]: { href: ROUTES.FINANCIAL, labelKey: 'routes.financial' },
	[ROUTES.STUDENTS]: { href: ROUTES.STUDENTS, labelKey: 'routes.students' },
	[ROUTES.B2B]: { href: ROUTES.B2B, labelKey: 'routes.b2b' },
	[ROUTES.RESULTS]: { href: ROUTES.RESULTS, labelKey: 'routes.results' },
	[ROUTES.RESET_PASSWORD]: { href: ROUTES.RESET_PASSWORD, labelKey: 'routes.resetPassword' },
};

export default BREADCRUMB_ROUTE_CONFIG;
